/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Withdrawal_UntilInputs */

const en_withdrawal_until = /** @type {(inputs: Withdrawal_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can withdraw until ${i?.date}`)
};

const pl_withdrawal_until = /** @type {(inputs: Withdrawal_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Możesz odstąpić do ${i?.date}`)
};

/**
* | output |
* | --- |
* | "You can withdraw until {date}" |
*
* @param {Withdrawal_UntilInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_until = /** @type {((inputs: Withdrawal_UntilInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_UntilInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_until(inputs)
	return en_withdrawal_until(inputs)
});